export default {
  // 获取新闻类别
  GET_LIST: '/jcnapi/news/category/getList',
  DEL: '/jcnapi/news/category/delete',
  //保存
  SAVE: '/jcnapi/news/category/save',
  GET_LIST_NEWS: '/jcnapi/news/getList',
  DEL_NEWS: '/jcnapi/news/delete',
  //保存
  SAVE_NEWS: '/jcnapi/news/save',
  //获取单条
  GET_NEWS: '/jcnapi/news/getInfo',
  SET_BANNER: '/jcnapi/news/setBanner',
  GET: '/jcnapi/news/getBanner'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/newManagement/index.js